import { createContext, useCallback, useContext, useState, type FC, type ReactNode } from "react";
import { useNavigate, type NavigateOptions } from "react-router-dom";

import { DEMO_ESTATE_ID } from "@/pages/demo/data/mockData";
import { DEMO_ROUTES } from "@/shared/constants/paths";

interface DemoModeContextValue {
  isDemoMode: boolean;
  selectedDemoEstateId: number;
  setSelectedDemoEstateId: (id: number) => void;
}

const DemoModeContext = createContext<DemoModeContextValue>({
  isDemoMode: false,
  selectedDemoEstateId: DEMO_ESTATE_ID,
  setSelectedDemoEstateId: () => undefined,
});

export const useDemoMode = () => useContext(DemoModeContext);

export function useNavigateToDemoEstate() {
  const { setSelectedDemoEstateId } = useDemoMode();
  const navigate = useNavigate();

  return useCallback(
    (estateId: number, options?: NavigateOptions) => {
      setSelectedDemoEstateId(estateId);
      navigate(`${DEMO_ROUTES.LAWYER_CLIENT}?estate=${estateId}`, options);
    },
    [setSelectedDemoEstateId, navigate],
  );
}

export const DemoModeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedDemoEstateId, setSelectedDemoEstateId] = useState<number>(DEMO_ESTATE_ID);

  return (
    <DemoModeContext.Provider
      value={{ isDemoMode: true, selectedDemoEstateId, setSelectedDemoEstateId }}
    >
      {children}
    </DemoModeContext.Provider>
  );
};
